







import { defineComponent, watch } from '@vue/composition-api';
import Button from '@/components/common/button.vue';
import { useUpgradeDialog } from '@/hooks/use-upgrade-dialog';
import { disableBodyScroll, enableBodyScroll } from '@/utils/page-scroll';

export default defineComponent({
  name: 'UpgradeDialog',
  components: {
    Button,
  },
  setup() {
    const { showData, hideDialog } = useUpgradeDialog();
    watch(showData, () => {
      if (showData.isShow) {
        disableBodyScroll();
      }
    });
    return {
      showData,
      hideGuide() {
        enableBodyScroll();
        hideDialog();
      },
    };
  },
});
